/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
import React, { useCallback, useEffect } from 'react'
import { useCarpartsCreditCard } from './CarpartsCreditCardContext'
import {
  BadgeContainer,
  CallToActionAnchor,
  BadgeContentContainer,
  BannerTitle,
  BannerBody,
} from './CarpartsCreditCardStyles.css'
import { useCarpartsCreditCardEnabled } from '../../hooks/useCarpartsCreditCardEnabled'
import GTM from '../../helpers/GTM'
import { CreditCardImage } from './CreditCardImage.svg'
import { CreditCardInfoIcon } from './CreditCardInfoIcon.svg'

const CallToAction = ({ text, onClick }) => {
  const handler = useCallback(() => {
    onClick()
  }, [onClick])
  return (
    <CallToActionAnchor
      href="https://www.carparts.concora.com/pre-qualify?mmcid=PACB70026010001"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handler}
      data-testid="cc-cart-prequal-now-button"
    >
      {text}
    </CallToActionAnchor>
  )
}

const BadgeContent = ({ openDrawer, widgetData }) => {
  const { callToAction } = widgetData?.creditCardBadgeContent

  useEffect(() => {
    GTM.creditCardBannerImpression('cart')
  }, [])

  const prequalify = useCallback(() => {
    GTM.creditCardPrequalClick('cart')
  }, [])

  const infoClick = useCallback(() => {
    GTM.creditCardInfoClick('cart')
    openDrawer()
  }, [openDrawer])

  return (
    <div data-testid="cc-cart-banner">
      <BadgeContainer>
        <CreditCardImage />
        <BadgeContentContainer>
          <BannerTitle>
            Earn 3% Cashback Rewards
            <sup>1</sup>
          </BannerTitle>
          <BannerBody>
            <span>
              on CarParts.com purchases with the CarParts.com Mastercard
              <sup>®</sup>
              .
            </span>
            {' '}
            <CallToAction text={callToAction} onClick={prequalify} />
            {' '}
            <span>
              no impact to your credit score.
              <sup>2</sup>
            </span>
            {' '}
            <CreditCardInfoIcon onClick={infoClick} />
          </BannerBody>
        </BadgeContentContainer>
      </BadgeContainer>
    </div>
  )
}

export const CarpartsCreditCardBadge = () => {
  const ccData = useCarpartsCreditCard()
  const isCarpartsCreditCardEnabled = useCarpartsCreditCardEnabled()
  if (!ccData?.openDrawer || !ccData?.widgetData?.creditCardBadgeContent || !isCarpartsCreditCardEnabled) {
    return null
  }

  return <BadgeContent openDrawer={ccData.openDrawer} widgetData={ccData.widgetData} />
}
